/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Image } from '@components/atoms'
import { PdfReader } from '@components/molecules'
// import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer'
import FileViewer from 'offices-viewer'

import config, { FileIconType } from '@configs'
import { grey } from '@mui/material/colors'
import { FileType } from '@schemas'

interface PropsType {
	file: FileType
}

export const Base64FileViewer = (props: PropsType) => {
	const { file } = props

	// state
	const [imageParentSize, setImageParentSize] = React.useState<{
		width: number
		height: number
	}>({
		width: 0,
		height: 0,
	})

	const fileNameArr: string[] = file.name !== '' ? file.name.split('.') : []
	const ext: string = fileNameArr.length > 0 ? fileNameArr[fileNameArr.length - 1] : ''
	const fileConfig: FileIconType = config.fileIcon(ext)
	const data = `data:${fileConfig.mimeType};base64, ${file.data}`

	const imageParentnRef = React.useRef<HTMLDivElement>(null)

	React.useLayoutEffect(() => {
		if (imageParentnRef.current) {
			if (
				imageParentnRef.current?.offsetHeight > 0 &&
				imageParentnRef.current?.offsetWidth > 0
			) {
				setImageParentSize({
					width: imageParentnRef.current?.offsetWidth,
					height: imageParentnRef.current?.offsetHeight,
				})
			}
		}
	}, [])

	return (
		<View css={style}>
			{ext.toLowerCase() === 'txt' ? (
				<></>
			) : // <DocViewer
			// 	documents={[{ uri: data, fileType: ext, fileName: file.name }]}
			// 	pluginRenderers={DocViewerRenderers}
			// 	config={{ header: { disableHeader: true, disableFileName: true } }}
			// />
			ext.toLowerCase() === 'pdf' ? (
				<PdfReader pdf={data} showDownload={true} />
			) : ['png', 'jpg', 'jpeg', 'bmp', 'gif'].includes(ext.toLowerCase()) ? (
				<View className="imageViewerView" ref={imageParentnRef}>
					<Image
						src={data}
						className="viewerImage"
						css={{
							width: imageParentSize.height > imageParentSize.width ? '100%' : 'auto',
							height: imageParentSize.width > imageParentSize.height ? 'auto' : '100%',
						}}
					/>
				</View>
			) : (
				<FileViewer key={file.name} fileType={ext} filePath={data} />
			)}
		</View>
	)
}

const style = css({
	position: 'relative',
	height: '100%',
	width: '100%',
	textAlign: 'left',

	'.imageViewerView': {
		position: 'relative',
		width: '100%',
		height: '100%',

		'.viewerImage': {
			position: 'absolute',
			margin: 'auto',
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
		},
	},

	'.pg-viewer-wrapper': {
		overflow: 'auto',
		height: '100%',
	},

	'.pg-viewer-wrapper blockquote, .pg-viewer-wrapper dir, .pg-viewer-wrapper dl, .pg-viewer-wrapper fieldset, .pg-viewer-wrapper form, .pg-viewer-wrapper h4, .pg-viewer-wrapper menu, .pg-viewer-wrapper ol, .pg-viewer-wrapper p, .pg-viewer-wrapper ul':
		{
			color: grey[800],
		},

	'.unsupported-message': {
		color: '#FFF',
	},
})
